import { useCallback, useRef, useState } from "react";
import LightGallery from "lightgallery/react";
import lgZoom from "lightgallery/plugins/zoom";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import Masonry from "react-masonry-css";

import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";

export default function Gallery({ images }) {
  const lightGalleryRef = useRef(null);
  const [imageErrors, setImageErrors] = useState({});

  const onInit = useCallback((detail) => {
    if (detail) {
      lightGalleryRef.current = detail.instance;
    }
  }, []);

  const openGallery = (index) => {
    if (lightGalleryRef.current) {
      lightGalleryRef.current.openGallery(index);
    }
  };

  const handleImageError = (index) => {
    setImageErrors((prev) => ({ ...prev, [index]: true }));
  };

  const getImageSrc = (img) => {
    if (typeof img === "string") return img;
    if (typeof img === "object" && img !== null) {
      return img.default || img;
    }
    return img;
  };

  const dynamicEl =
    images?.map((img) => {
      const src = getImageSrc(img);
      return {
        src: src,
        thumb: src,
      };
    }) || [];

  const breakpointColumnsObj = {
    default: 3,
    1100: 3,
    700: 2,
    500: 1,
  };

  if (!images || images.length === 0) {
    return (
      <div className="section--spacing-x flex items-center justify-center py-20">
        <p className="description--styles text-xl text-gray-500">
          No images available
        </p>
      </div>
    );
  }

  return (
    <div className="section--spacing-x mt-10">
      {/* <h2 className="mb-8 heading--one text-secondary">Project Gallery</h2> */}

      <Masonry
        breakpointCols={breakpointColumnsObj}
        className="my-masonry-grid"
        columnClassName="my-masonry-grid_column"
      >
        {dynamicEl.map((img, index) => (
          <button
            key={index}
            onClick={() => openGallery(index)}
            className="mb-4 block overflow-hidden rounded-lg transition-transform duration-300 hover:scale-[1.02] focus:outline-none focus:ring-2 focus:ring-secondary"
          >
            <img
              src={imageErrors[index] ? "/placeholder-image.jpg" : img.thumb}
              alt={`Gallery ${index + 1}`} // Fixed: Removed redundant "image" word
              className="h-auto w-full object-cover"
              onError={() => handleImageError(index)}
              loading="lazy"
            />
          </button>
        ))}
      </Masonry>

      <LightGallery
        dynamic
        dynamicEl={dynamicEl}
        plugins={[lgZoom, lgThumbnail]}
        onInit={onInit}
        container={document.body}
        elementClassNames="hidden"
        speed={500}
        download={false}
        zoom={true}
        thumbnail={true}
        autoplay={false}
        showThumbByDefault={true}
        thumbWidth={100}
        thumbHeight={80}
        thumbMargin={5}
      />
    </div>
  );
}
